import { CONFIG } from '../config.js';
import { MARKETS } from './registry.js';
/** The largest multiplier across a per-outcome market's options — the "up to ×N"
 *  headline shown before the player has chosen a side. 0 when none carry one. */
function topOptionMultiplier(m) {
    let max = 0;
    for (const o of m.options ?? [])
        if ((o.multiplier ?? 0) > max)
            max = o.multiplier;
    return max;
}
/** The ×N a CORRECT leg pays. For a FLAT market it's the market multiplier; for a
 *  PER-OUTCOME market it's the chosen option's multiplier (or, with no selection, the
 *  headline top option). 1 for the anchor / unknown id, so it never inflates a score. */
export function legMultiplier(marketId, selection) {
    const m = MARKETS[marketId];
    if (!m || m.anchor)
        return 1;
    if (selection != null && m.options) {
        const optMult = m.options.find((o) => o.value === selection)?.multiplier;
        if (optMult != null)
            return optMult;
    }
    if (m.multiplier != null)
        return m.multiplier;
    return topOptionMultiplier(m) || 1;
}
/** The card's combined multiplier — the product of every stacked leg's multiplier
 *  (the ×N badge in the bet slip). Each leg is priced by its chosen outcome. Bare
 *  anchor → 1. */
export function cardMultiplier(legs) {
    let m = 1;
    for (const l of legs)
        m *= legMultiplier(l.marketId, l.selection);
    return m;
}
/** Best-case "to win": the points if the 1X2 base lands AND every boost hits —
 *  `BASE × Π multiplier`, rounded like the real score. This is the headline number
 *  the builder shows; the downside is always exactly `−BASE` (`cardAtRisk`). */
export function cardToWin(legs) {
    return Math.round(CONFIG.COMBO.BASE_POINTS * cardMultiplier(legs));
}
/** The "floor when right": the points if the 1X2 base LANDS but every stacked boost
 *  MISSES — `BASE × Π(multiplier^(−WRONG_LEG_EXPONENT))`, rounded like the real score.
 *  With no boosts this is exactly `BASE`; each boost added drops it further below
 *  `BASE`. This is the honest "boosts aren't free" number: stacking a boost puts the
 *  safe base itself at risk, it doesn't only add upside. (Mirrors `cardScore` for an
 *  anchor-right card whose every gradeable leg missed.) */
export function cardFloor(legs) {
    let m = 1;
    for (const l of legs)
        m *= Math.pow(legMultiplier(l.marketId, l.selection), -CONFIG.COMBO.WRONG_LEG_EXPONENT);
    return Math.round(CONFIG.COMBO.BASE_POINTS * m);
}
/** The fixed downside of any card: a wrong 1X2 base costs the whole base. */
export const cardAtRisk = -CONFIG.COMBO.BASE_POINTS;
export function riskTier(multiplier) {
    if (multiplier <= 1.5)
        return 'SAFE';
    if (multiplier < 2.0)
        return 'MEDIUM';
    return 'BOLD';
}
//# sourceMappingURL=projections.js.map